var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"block mb-4 text-xs"},[_c('ol',{staticClass:"breadcrumb-list"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{staticClass:"hover:underline",attrs:{"to":{ name: 'index' }}},[_vm._v("首頁")])],1),_c('li',{staticClass:"breadcrumb-item"},[_c('a',[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }